// linkBase is '' on the home page and '/' on other pages, so '#top' becomes '/#top'.
export default function Logo({ linkBase = '' }) {
  return (
    <a href={`${linkBase}#top`} className="logo">
      <span className="logo-word">VenueLista</span>
      <span className="logo-sub">Marketplace for Venues</span>
    </a>
  )
}
